import clsx from 'clsx'
import type { DataTableInstance, DataTableRowData } from '../../types'

interface Props<TData extends DataTableRowData> {
  table: DataTableInstance<TData>
}

export const ToolbarInternalButtons = <TData extends DataTableRowData>({
  table,
  ...rest
}: Props<TData>) => {
  const {
    options: { renderToolbarInternalActions },
  } = table

  return (
    <div
      {...rest}
      className={clsx('mrt-toolbar-internal-buttons flex items-center gap-0.5 z-[3] ml-1')}
    >
      {renderToolbarInternalActions?.({ table }) ?? null}
    </div>
  )
}
